import { Component } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { AppService } from '../../service/app.service';
import { Utente } from '../../interfaces/user';
import { CommonModule } from '@angular/common';
import { EntiComponent } from '../anagrafica-ente/enti.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, EntiComponent],
  templateUrl: './home.component.html',
})
export class HomeComponent {
  constructor(
    private loader: LoaderService,
    private router: Router,
    private authService: MsalService,
    private appService: AppService
  ) {}
  user = this.authService.instance.getAllAccounts()[0];
  utente: Utente = {};

  ngOnInit(): void {
    this.utente = this.appService.user;
    this.loader.hide();
  }

  redirect(url: string) {
    this.router.navigate([url]);
  }

}
